export const MARKER_COUNT_LIMIT = 50;

export const MAP_QUERY_DEBOUNCE_MS = 1000;

export const MAP_QUERY_DEBOUNCE_SHORT_MS = 500;

export const MAX_VISIBLE_ZOOM_METER = {
  default: 500,
  tile: 500,
  nearby_info: 500,
  nearby_franchise: -1, // 제한 없음
  find_store: -1, // 제한 없음
  anaysis: 3_000,
  ruler: 10_000,
  mobile_markers: -1, // -1일 경우 줌 제한 없음
  mobile_new_store_name: 300,
};

export const INVALID_POLYGON_ERROR = 'Loop is not valid';
